module.exports = "/_next/static/resources/life2-f77b9b7694216ba9965e6e0546f8cca5.webp";